import type { MetricsService } from "./MetricsService";

export type ErrorContext = Record<string, unknown> & {
  operation: string;
  userId?: string;
  recordIds?: string[];
  projectId?: string;
};

export class ErrorHandlerService {
  private readonly metricsService: MetricsService;

  constructor(metricsService: MetricsService) {
    this.metricsService = metricsService;
  }

  handleError(error: Error, context: ErrorContext): string {
    const userMessage = this.getUserFriendlyMessage(error, context);

    // Логируем ошибку
    console.error(`Error in ${context.operation}:`, {
      error: error.message,
      stack: error.stack,
      context,
    });

    // Записываем метрику
    this.metricsService.recordMetric({
      operation: context.operation,
      duration: 0,
      success: false,
      error: error.message,
      metadata: context,
    });

    return userMessage;
  }

  private getUserFriendlyMessage(error: Error, context: ErrorContext): string {
    if (error.message.includes("404")) {
      return "Record not found";
    }
    if (error.message.includes("403")) {
      return "You do not have permission to perform this action";
    }
    if (error.message.includes("network")) {
      return "Network error. Please check your connection and try again";
    }
    return `Failed to ${context.operation}. Please try again`;
  }
}
